<template>
  <div>
    <div class="row">
      <div class="col-sm">
        <h1>Body weight</h1>
      </div>
      <div class="col-sm">
        <button
          id="measurement-create-button"
          class="btn btn-primary float-sm-right"
          v-on:click="moveToWeightCreateView()"
        >+ New measurement</button>
      </div>
    </div>

    <div class="row" style="align-items: center;" v-if="store.getWeighingResultsCount() > 0">
      <div class="col-sm">
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <a
              role="button"
              class="nav-link"
              v-bind:class="{active: selectedView == 'list'}"
              v-on:click="$router.push({ name: 'weight.list'})"
            >List</a>
          </li>
          <li class="nav-item">
            <a
              role="button"
              class="nav-link"
              v-bind:class="{active: selectedView == 'chart'}"
              v-on:click="$router.push({ name: 'weight.chart'})"
            >Chart</a>
          </li>
          <li class="nav-item">
            <a
              role="button"
              class="nav-link"
              v-bind:class="{active: selectedView == 'scales'}"
              v-on:click="$router.push({ name: 'weight.scales'})"
            >Scales</a>
          </li>
        </ul>
      </div>
    </div>

    <div id="weight-main-content" v-if="store.getWeighingResultsCount() > 0">
      <weight-list v-if="selectedView == 'list'" />
      <measurement-chart
        :measurements="store.state.weighingResults"
        measurementName="Body weight"
        measurementUnit="kg"
        :measurementDivider="1000"
        measurementProperty="weight"
        color="rgb(54, 162, 235)"
        v-if="selectedView == 'chart'"
      />
      <scales v-if="selectedView == 'scales'" />
    </div>

    <div id="no-weighing-results-info" v-else>
      <p>
        You have no weighing results yet.
        <br />Make sure to add the first one right now.
        <br />You might want to consider
        <router-link :to="{ name: 'scales'}">adding a scale</router-link>&nbsp;also.
      </p>
    </div>
  </div>
</template>

<script>
import { store } from "@/store.js";
import WeightList from "@/components/WeightList.vue";
import MeasurementChart from "@/components/MeasurementChart.vue";
import Scales from "@/views/Scales.vue";

export default {
  name: "WeighingResultView",
  components: { WeightList, MeasurementChart, Scales },
  data: function() {
    return {
      store: store
    };
  },
  computed: {
    selectedView: function() {
      if (this.$route.name === "weight.chart") return "chart";

      if (this.$route.name === "weight.scales") return "scales";

      return "list";
    }
  },
  created: function() {},
  mounted: function() {},
  methods: {
    moveToWeightCreateView() {
      this.store.state.weightView.cancelRoute = "weight";
      this.$router.push({
        name: "weight.create"
      });
    }
  }
};
</script>

<style scoped>
#weight-measurement-info {
  font-size: 200%;
  color: #111;
}

#no-weighing-results-info {
  font-size: 140%;
}

.main-content-row {
  padding-top: 1rem;
}

.nav-tabs {
  margin-top: 1em;
}

.nav-tabs .nav-link {
  color: gray;
  cursor: pointer;
}
</style>
